module.exports = __webpack_public_path__ + "static/media/feather.3a391392.svg";